import { convertToRgba as C, HEX_COLORS as g, TransparencyEnum as A } from "@partoohub/branding";
import { isEqual as _ } from "date-fns";
import { enGB as R } from "date-fns/locale/en-GB";
import { defaultDateCriteriaTranslation as M, DatePickerType as l, DateCriteria as a, DEFAULT_PERIOD as L, DatePickerInputName as E } from "../../types/components/dateRangePicker.js";
const d = {
  name: "en",
  locale: R
}, w = 12, m = 4, H = 7, Y = "dd/mm/YYYY", S = "mm/YYYY", P = "Select date", b = "Select month", y = {
  startDate: "Start Date",
  endDate: "End Date"
}, B = {
  startDate: Y
}, I = {
  endDate: S
}, k = {
  day: "2-digit",
  month: "2-digit",
  year: "numeric"
}, v = {
  year: "numeric",
  month: "2-digit"
}, W = (e, n) => e ? {
  background: n.colors.primary.alpha,
  border: n.colors.primary.initial,
  boxShadow: `0px 0px 0px 3px ${n.colors.primary.alpha}`,
  colorVariant: "default"
} : {
  background: C(g.grey, A.ALPHA),
  border: "transparent",
  colorVariant: "default"
}, G = (e, n = L) => {
  const t = /* @__PURE__ */ new Date();
  switch (e) {
    case a.TODAY:
      return {
        start: new Date(Date.UTC(t.getUTCFullYear(), t.getUTCMonth(), t.getUTCDate())),
        end: new Date(Date.UTC(t.getUTCFullYear(), t.getUTCMonth(), t.getUTCDate()))
      };
    case a.LAST_WEEK:
      return {
        start: new Date(Date.UTC(t.getUTCFullYear(), t.getUTCMonth(), t.getUTCDate() - 7)),
        end: new Date(Date.UTC(t.getUTCFullYear(), t.getUTCMonth(), t.getUTCDate() - 1))
      };
    case a.LAST_MONTH:
      return {
        start: new Date(Date.UTC(t.getUTCFullYear(), t.getUTCMonth() - 1, 1)),
        end: new Date(Date.UTC(t.getUTCFullYear(), t.getUTCMonth(), 0))
      };
    case a.CURRENT_MONTH:
      return {
        start: new Date(Date.UTC(t.getUTCFullYear(), t.getUTCMonth(), 1)),
        end: new Date(Date.UTC(t.getUTCFullYear(), t.getUTCMonth() + 1, 0))
      };
    case a.LAST_THREE_MONTHS:
      return {
        start: new Date(Date.UTC(t.getUTCFullYear(), t.getUTCMonth() - 3, 1)),
        end: new Date(Date.UTC(t.getUTCFullYear(), t.getUTCMonth(), 0))
      };
    case a.LAST_TWELVE_MONTHS:
      return {
        start: new Date(Date.UTC(t.getUTCFullYear(), t.getUTCMonth() - 12, 1)),
        end: new Date(Date.UTC(t.getUTCFullYear(), t.getUTCMonth(), 0))
      };
    case a.PERIOD:
      return {
        start: new Date(Date.UTC(t.getUTCFullYear(), t.getUTCMonth() - n, 1)),
        end: new Date(Date.UTC(t.getUTCFullYear(), t.getUTCMonth(), 0))
      };
    case a.CURRENT_YEAR:
      return {
        start: new Date(Date.UTC(t.getUTCFullYear(), 0, 1)),
        end: new Date(Date.UTC(t.getUTCFullYear(), t.getUTCMonth(), t.getUTCDate()))
      };
    case a.LAST_YEAR:
      return {
        start: new Date(Date.UTC(t.getUTCFullYear() - 1, 0, 1)),
        end: new Date(Date.UTC(t.getUTCFullYear(), 0, 0))
      };
    default:
      return {
        start: null,
        end: null
      };
  }
}, F = (e) => {
  switch (e) {
    case l.DateSelector:
    case l.DateRangePicker:
      return [a.TODAY, a.LAST_WEEK, a.LAST_MONTH, a.CURRENT_MONTH, a.LAST_THREE_MONTHS, a.LAST_TWELVE_MONTHS, a.PERIOD, a.CURRENT_YEAR, a.LAST_YEAR];
    case l.MonthSelector:
    case l.MonthRangePicker:
      return [a.LAST_MONTH, a.CURRENT_MONTH, a.LAST_THREE_MONTHS, a.LAST_TWELVE_MONTHS, a.PERIOD, a.CURRENT_YEAR, a.LAST_YEAR];
    default:
      return [];
  }
}, x = (e) => F(e).map((n) => ({
  label: M[n],
  name: n
})), V = (e, n, t) => {
  const r = new Date(t.getFullYear(), t.getMonth());
  return !(e && new Date(e?.getFullYear() ?? 0, e?.getMonth() ?? 0) > r || n && new Date(n?.getFullYear() ?? 0, n?.getMonth() ?? 0) < r);
}, q = (e, n, t) => !(e && e > t || n && n < t), K = (e, n, t, r) => {
  const [o, T] = e;
  o && T ? t([T, null]) : o && t([o, null]), r(E.EndDate), n([null, null]);
}, X = (e, n, t, r, o) => {
  const [T, s] = e, [D, U] = n, i = T && s, u = D !== null && U !== null, c = i ? _(T, s) : !1;
  u && T !== null && T > D && !c ? r([D, T]) : (r(e), t(e)), o(E.EndDate);
}, $ = (e) => e === "bottom-left" || e === "top-left", j = (e) => e === "top-left" || e === "top-right", z = (e, n, t) => {
  const r = n === "ar" ? d.name : n;
  return e ? new Date(e).toLocaleString(r, t) : "";
};
export {
  Y as DEFAULT_DATE_FORMAT,
  P as DEFAULT_DATE_LABEL,
  k as DEFAULT_FORMAT_DATE,
  v as DEFAULT_FORMAT_MONTH,
  d as DEFAULT_LOCALE,
  S as DEFAULT_MONTH_FORMAT,
  b as DEFAULT_MONTH_LABEL,
  B as DEFAULT_RANGE_DATE_PLACEHOLDERS,
  y as DEFAULT_RANGE_LABELS,
  I as DEFAULT_RANGE_MONTH_PLACEHOLDERS,
  w as NUMBER_OF_MONTHS,
  H as NUMBER_YEAR_DISPLAYED_AFTER_CURRENT,
  m as NUMBER_YEAR_DISPLAYED_BEFORE_CURRENT,
  x as buildShortcutItems,
  z as formatDate,
  F as getAvailableShortcuts,
  G as getDateByCriteria,
  W as getDateSelectorConfig,
  V as isMonthWithinRange,
  $ as isPositionLeft,
  j as isPositionTop,
  q as isYearWithinRange,
  X as updateRangeEnd,
  K as updateRangeStart
};
